// extracted by mini-css-extract-plugin
export default {"message":"ZIMvBcPGkR"};